import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { createRoutine } from 'redux-saga-routines';
import {
  ContainerState,
  I_CollectionPortfolio,
  I_Portfolio,
} from './typesIndex';

// The initial state of the App container
export const initialState: ContainerState = {
  loading: false,
  success: false,
  error: false,
  portfolio: null,
  menuCollectionSelected: '',
};

export const GET_PORTFOLIO = createRoutine('App/getPortfolio');
export const UPDATE_VIEW_COUNT_BY_PROJECTS = createRoutine(
  'App/updateViewCountByProjects',
);

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    onChangeMenuCollectionSelected(state, action: PayloadAction<string>) {
      state.menuCollectionSelected = action.payload;
    },
    resetStatusPage(state) {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.success = initialState.success;
    },
  },
  extraReducers: {
    [HYDRATE]: (_state: ContainerState, action: PayloadAction<any>) =>
      action.payload.app,
    /**
     * ! GET_PORTFOLIO
     */
    [GET_PORTFOLIO.TRIGGER]: (
      state,
      // action: PayloadAction<{ id: string }>,
    ) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_PORTFOLIO.SUCCESS]: (
      state,
      action: PayloadAction<{ portfolio: I_Portfolio; menuCollectionSelected }>,
    ) => {
      const { portfolio, menuCollectionSelected } = action.payload;
      state.portfolio = portfolio;
      const menuCollections = menuCollectionSelected
        ? state.portfolio.menu.filter(
            item => item.id === menuCollectionSelected && item.collection,
          )
        : state.portfolio.menu.filter(
            item => item.type === 'collection' && item.collection,
          ) ||
          state.portfolio.menu.filter(
            item => item.type === 'collection' && item.collection,
          );
      if (menuCollections.length)
        state.menuCollectionSelected = menuCollections[0].id;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_PORTFOLIO.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! UPDATE_VIEW_COUNT_BY_PROJECTS
     */
    [UPDATE_VIEW_COUNT_BY_PROJECTS.TRIGGER]: state => {
      state.error = false;
    },
    [UPDATE_VIEW_COUNT_BY_PROJECTS.SUCCESS]: (
      state,
      action: PayloadAction<I_CollectionPortfolio>,
    ) => {
      state.portfolio.collections.forEach(item => {
        if (item.id === action.payload.id)
          item.viewCountByProjects = action.payload.viewCountByProjects;
      });
      state.error = false;
    },
    [UPDATE_VIEW_COUNT_BY_PROJECTS.FAILURE]: state => {
      state.error = true;
    },
  },
});

export const { actions, reducer, name: sliceKey } = appSlice;

export default reducer;
